import type { ThemeId } from '../contexts/ThemeContext';

export const MAP_RAMPS: Record<ThemeId, string[]> = {
  dark: ['#1f2a26', '#2f4a3d', '#5a6b3c', '#9a8a3a', '#e0a843', '#fbe1a2'],
  light: ['#eceee6', '#cfe0c4', '#9cc48a', '#e2b04a', '#c4651a', '#7a2e08'],
  color: ['#fdeef6', '#fbc4de', '#f472b6', '#c026d3', '#7c3aed', '#3b0764'],
};

export const MAP_RAMP = MAP_RAMPS.dark;

function hexToRgb(hex: string): [number, number, number] {
  const h = hex.replace('#', '');
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}

export function rampColor(t: number, stops: string[] = MAP_RAMP): string {
  const c = Math.min(1, Math.max(0, t));
  const seg = c * (stops.length - 1);
  const i = Math.min(stops.length - 2, Math.floor(seg));
  const f = seg - i;
  const a = hexToRgb(stops[i]);
  const b = hexToRgb(stops[i + 1]);
  const mix = (k: number) => Math.round(a[k] + (b[k] - a[k]) * f);
  return `rgb(${mix(0)}, ${mix(1)}, ${mix(2)})`;
}

export function rampLegend(stops: string[] = MAP_RAMP): string {
  return `linear-gradient(to right, ${stops.join(', ')})`;
}
